import { Link } from "react-router-dom";
import { useFetch } from "@/lib/content";

const CARDS = [
  { key: "case-studies", label: "Case Studies", to: "/admin/case-studies" },
  { key: "services", label: "Service Series", to: "/admin/services" },
  { key: "posts", label: "Blog Posts", to: "/admin/posts" },
  { key: "testimonials", label: "Testimonials", to: "/admin/testimonials" },
  { key: "team", label: "Team Members", to: "/admin/team" },
  { key: "leads", label: "Leads", to: "/admin/leads" },
];

export default function AdminDashboard() {
  const { data: stats } = useFetch("/admin/stats");

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-4xl font-medium tracking-tight">Dashboard</h1>
      <p className="mt-2 text-sm text-slategray">Content health and the latest lead activity.</p>

      <div className="mt-10 grid gap-px border border-ash bg-ash sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`stat-${c.key}`} className="group bg-paper p-8 transition-colors hover:bg-ash/40">
            <p className="font-serif text-5xl font-semibold">{stats?.counts?.[c.key] ?? "—"}</p>
            <p className="mt-2 flex items-center justify-between text-[12px] font-bold uppercase tracking-[0.16em] text-slategray">
              {c.label}
              <span className="text-progress opacity-0 transition-opacity group-hover:opacity-100">Manage →</span>
            </p>
          </Link>
        ))}
      </div>

      <div className="mt-14">
        <div className="flex items-center justify-between">
          <h2 className="font-serif text-2xl font-medium">Recent leads</h2>
          {stats?.counts?.new_leads > 0 && (
            <p data-testid="new-leads-badge" className="bg-progress px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white">
              {stats.counts.new_leads} new
            </p>
          )}
        </div>
        {!stats?.recent_leads?.length ? (
          <div className="mt-6 border border-ash p-14 text-center">
            <p className="font-serif text-2xl">No leads yet.</p>
            <p className="mt-2 text-sm text-slategray">
              Discovery call and contact form submissions will appear here and be emailed to you.
            </p>
          </div>
        ) : (
          <table className="mt-6 w-full border border-ash text-left text-sm">
            <thead>
              <tr className="border-b border-ash bg-ash/40 text-[11px] uppercase tracking-[0.16em] text-slategray">
                <th className="p-4 font-bold">Name</th>
                <th className="p-4 font-bold">Company</th>
                <th className="p-4 font-bold">Pain</th>
                <th className="hidden p-4 font-bold md:table-cell">Source</th>
                <th className="hidden p-4 font-bold md:table-cell">When</th>
              </tr>
            </thead>
            <tbody>
              {stats.recent_leads.map((l) => (
                <tr key={l.id} className="border-b border-ash/70 last:border-b-0">
                  <td className="p-4 font-semibold">{l.name}</td>
                  <td className="p-4">{l.company || "—"}</td>
                  <td className="p-4 text-slategray">{l.pain_area || "—"}</td>
                  <td className="hidden p-4"><span className="bg-ash px-2 py-1 text-[11px] font-bold uppercase">{l.source}</span></td>
                  <td className="hidden p-4 text-slategray">{(l.created_at || "").slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <Link to="/admin/leads" className="mt-6 inline-block text-[12px] font-bold uppercase tracking-[0.14em] text-progress">
          View all leads →
        </Link>
      </div>
    </div>
  );
}
